import { v4 as uuid } from "uuid";

import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { ISelfEvaluation } from "../types";

export interface ISelfEvaluationCreateMutationParameters {
    uuid: string;
    title: string;
    periodStart: string;
    periodEnd: string;
    achievements?: string;
    challenges?: string;
    description: string;
    skillLevels: string[];
    skills: string[];
    tools?: string;
    links?: string[];
}

export type ISelfEvaluationCreateMutationResult = ISelfEvaluation;

export const selfEvaluationCreateMutation: IApiMutationFunction<ISelfEvaluationCreateMutationParameters> = ({
    uuid: providedUuid,
    tools,
    links,
    ...data
}) => ({
    method: "POST",
    url: "/self_evaluations",
    data: {
        ...data,
        uuid: providedUuid ?? uuid(),
        tools: tools ?? "",
        links: links ?? [],
    },
});

export const useSelfEvaluationCreateMutation = createApiMutationHook<
    ISelfEvaluationCreateMutationParameters,
    ISelfEvaluationCreateMutationResult
>(selfEvaluationCreateMutation);
